import * as ActionTypes from '../constants/ActionTypes'
import { getRequest, postRequest_ } from './http'
import { baseurl } from '../constants/constants';
import {
    queryAllPermisions
} from "../data_base_local/dataservice";

export function setData(items, name) {
    return {
        type: ActionTypes.SET_DATA,
        name: name,
        items: items
    }
}

const get_ = (data, controller) => {
    return (dispatch) => {
        getRequest(data, controller).then(
            (response) => {
                if (data.typeOption == "get_data_default") {

                    dispatch(setData({
                        price_groups_array: response.data.price_groups_array,
                        businessLocations: response.data.businessLocations,
                        cash_register_util: response.data.cash_register_util
                    }));

                    window.localStorage.setItem('current_register', JSON.stringify(response.data.cash_register_util.current_register));
                } else if (data.typeOption == "get_data_module") {
                    dispatch(setData({
                        data_module: response.data
                    }));
                }
            },
            (err) => {
            }
        );
    }
};

const post_ = (data, controller) => {
    return (dispatch) => {
        postRequest_(data, controller).then(
            (response) => {
                console.log(response);
                if (!response.data.success) {
                    dispatch(setData({
                        response: { Msg: "A ocurrido un error: " + response.data.msg },
                        simpleToast: true
                    }));

                } else {

                    if (data.typeOption == "saveDataUser") {

                        window.localStorage.setItem('islogued', 'true');
                        window.localStorage.setItem('data_login_ncpos_app', JSON.stringify({
                            id: response.data.user.id,
                            email: response.data.user.email,
                            first_name: response.data.user.first_name,
                            last_name: response.data.user.last_name,
                            username: response.data.user.username,
                            contact_number: response.data.user.contact_number,
                            password: response.data.password,
                        }));
                        window.location.href = baseurl() + "/dashboard/home";

                        dispatch(setData({
                            response: { Msg: response.data.msg, redirect: false, success: response.data.success },
                            simpleToast: true
                        }));

                    } else if (data.typeOption == "saveDataRegister") {

                        dispatch(setData({
                            data_default: response.data.get_data_default,
                            response: { Msg: response.data.msg, redirect: false, success: response.data.success },
                            simpleToast: true,
                            pos_location_id: data.fields_register.location_id,
                        }));

                    } else if (data.typeOption == "closeDataRegister") {

                        dispatch(setData({
                            data_default: response.data.get_data_default,
                            response: { Msg: response.data.msg, redirect: false, success: response.data.success },
                            simpleToast: true
                        }));

                    }
                }
            },
            (err) => {

            }
        );
    }
};

const validate_permission_ = async () => {
    return await queryAllPermisions();
};

export default {
    setData,
    get_,
    post_,
    validate_permission_
}
